/*** IMPORTS FROM imports-loader ***/
var define = false;

import tagTester from './_tagTester.js';
import has from './_has.js';

var isArguments = tagTester('Arguments');

// Define a fallback version of the method in browsers (ahem, IE < 9), where
// there isn't any inspectable "Arguments" type.
(function() {
  if (!isArguments(arguments)) {
    isArguments = function(obj) {
      return has(obj, 'callee');
    };
  }
}());

export default isArguments;




//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/isArguments.js
// module id = 37
// module chunks = 0